import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import defaultStyles from '../GridHeaderButton.module.scss';

const SimpleGridHeaderButton = props => (
    <button
        className={ props.styles.gridHeaderButton }
        type="button"
        onClick={ props.onClick }
    >
        {props.text} {props.children}
    </button>
);

SimpleGridHeaderButton.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.shape({})
    ]),
    onClick: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    text: PropTypes.string
};

SimpleGridHeaderButton.defaultProps = {
    children: [],
    onClick: noop,
    styles: defaultStyles,
    text: ''
};

export default SimpleGridHeaderButton;
